var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "#403E3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02 9.82L7.6 8.4V6.4H8.4V8.07L9.58 9.25L9.02 9.82ZM8 12C7.44667 12 6.92667 11.8949 6.44 11.6848C5.95333 11.4749 5.53 11.19 5.17 10.83C4.81 10.47 4.52507 10.0467 4.3152 9.56C4.10507 9.07333 4 8.55333 4 8C4 7.44667 4.10507 6.92667 4.3152 6.44C4.52507 5.95333 4.81 5.53 5.17 5.17C5.53 4.81 5.95333 4.52493 6.44 4.3148C6.92667 4.10493 7.44667 4 8 4C8.55333 4 9.07333 4.10493 9.56 4.3148C10.0467 4.52493 10.47 4.81 10.83 5.17C11.19 5.53 11.4749 5.95333 11.6848 6.44C11.8949 6.92667 12 7.44667 12 8C12 8.55333 11.8949 9.07333 11.6848 9.56C11.4749 10.0467 11.19 10.47 10.83 10.83C10.47 11.19 10.0467 11.4749 9.56 11.6848C9.07333 11.8949 8.55333 12 8 12ZM8 11.2C8.89333 11.2 9.65 10.89 10.27 10.27C10.89 9.65 11.2 8.89333 11.2 8C11.2 7.10667 10.89 6.35 10.27 5.73C9.65 5.11 8.89333 4.8 8 4.8C7.10667 4.8 6.35 5.11 5.73 5.73C5.11 6.35 4.8 7.10667 4.8 8C4.8 8.89333 5.11 9.65 5.73 10.27C6.35 10.89 7.10667 11.2 8 11.2Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3a686727f384cca4ba8f403255a73bd8.svg";
export { ForwardRef as ReactComponent };